import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
    ReferenceField,
    ReferenceInput,
    SelectInput,
} from 'react-admin';

const TargetFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" />
        <ReferenceInput
            label="Instances"
            source="instance_id"
            reference="instances"
            allowEmpty
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

const TargetList = props => (
    <List {...props} filters={<TargetFilter />}>
        <Datagrid>
            <TextField source="id" />
            <ReferenceField label="Instances" source="instance_id" reference="instances">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="name" />
            <TextField source="type" />
            <TextField source="account_name" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default TargetList;